<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" *ngIf="formData">
  <div class="relative w-full max-w-3xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col max-h-[90vh] animate-fade-in-up">

    <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <!-- Header -->
    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">assignment</span>
          {{ formData.id ? 'แก้ไขคำขอโควต้า' : 'สร้างคำขอโควต้า' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          บันทึก draft หรือส่งเข้ากระบวนการอนุมัติ
        </p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isLoading()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-5">

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            Client <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">store</span>
            <select [(ngModel)]="formData.clientId" (ngModelChange)="onClientChange()" [disabled]="isClientFieldLocked || isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none disabled:opacity-60">
              <option [ngValue]="0">-- เลือก Client --</option>
              <option *ngFor="let c of clients" [ngValue]="c.id">{{ c.name }}</option>
            </select>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            ประเภทคำขอ <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">swap_vert</span>
            <select [(ngModel)]="formData.requestType" (ngModelChange)="onRequestTypeChange()" [disabled]="isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
              <option *ngFor="let t of requestTypes" [value]="t.value">{{ t.label }}</option>
            </select>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">จำนวนที่ขอ</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">tag</span>
            <input type="number" min="0" [(ngModel)]="formData.requestedQty" [disabled]="isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">ระดับโควต้า</label>
          <select [(ngModel)]="formData.quotaLevel" [disabled]="isLoading()"
            class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
            <option *ngFor="let l of quotaLevels" [value]="l.value">{{ l.label }}</option>
          </select>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">ขอบเขตบัตร</label>
          <select [(ngModel)]="formData.cardScope" [disabled]="isLoading()"
            class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
            <option *ngFor="let s of cardScopes" [value]="s.value">{{ s.label }}</option>
          </select>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">วันที่มีผล</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">event</span>
            <input type="date" [(ngModel)]="formData.effectiveDate" [disabled]="isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
          </div>
        </div>

        <div *ngIf="needsTargetQuota" class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            โควต้าเป้าหมาย <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">account_balance_wallet</span>
            <select [(ngModel)]="formData.targetQuotaId" [disabled]="isLoading()"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none">
              <option [ngValue]="null">-- เลือกโควต้า --</option>
              <option *ngFor="let q of targetQuotas" [ngValue]="q.id">
                {{ q.name }} (อนุมัติ: {{ q.quotaApproved }}, ใช้แล้ว: {{ q.quotaUsed }})
              </option>
            </select>
          </div>
        </div>

        <div *ngIf="isSuspend" class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
            โหมดระงับ <span class="text-rose-500">*</span>
          </label>
          <select [(ngModel)]="formData.suspendCardMode" [disabled]="isLoading()"
            class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200">
            <option [ngValue]="null">-- เลือกโหมดระงับ --</option>
            <option *ngFor="let m of suspendModes" [value]="m.value">{{ m.label }}</option>
          </select>
        </div>

        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">หมายเหตุ</label>
          <div class="relative flex items-start bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200">
            <span class="absolute left-3 top-3 material-icons text-slate-400 text-lg pointer-events-none">notes</span>
            <textarea [(ngModel)]="requestRemark" rows="3" [disabled]="isLoading()" placeholder="หมายเหตุเพิ่มเติม (ถ้ามี)"
              class="w-full pl-10 pr-4 py-3 bg-transparent border-none text-sm font-medium focus:outline-none resize-none"></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex-none px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-end gap-3 bg-white/95 dark:bg-slate-900/95">
      <button type="button" (click)="onClose()" [disabled]="isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        ยกเลิก
      </button>
      <button type="button" (click)="onSaveDraft()" [disabled]="isLoading()"
        class="px-5 py-2.5 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 font-bold hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors disabled:opacity-50">
        บันทึก Draft
      </button>
      <button type="button" (click)="onSubmitApproval()" [disabled]="isLoading()"
        class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50">
        ส่งอนุมัติ
      </button>
    </div>
  </div>
</div>
